"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var Notification_1 = require("./svg-components/Notification");

var Desk_1 = require("./svg-components/Desk");

var Delete_1 = require("./svg-components/Delete");

var List_1 = require("./svg-components/List");

var Telegram_1 = require("./svg-components/Telegram");

var Teams_1 = require("./svg-components/Teams");

var Smarphone_1 = require("./svg-components/Smarphone");

var Trash_1 = require("./svg-components/Trash");

var Dropdown_1 = require("./svg-components/Dropdown");

var CheckboxChecked_1 = require("./svg-components/CheckboxChecked");

var ArrowLeft_1 = require("./svg-components/ArrowLeft");

var Send_1 = require("./svg-components/Send");

var Payment_1 = require("./svg-components/Payment");

var Divider_1 = require("./svg-components/Divider");

var Backward_1 = require("./svg-components/Backward");

var SeeTranscript_1 = require("./svg-components/SeeTranscript");

var Cards_1 = require("./svg-components/Cards");

var Conversion_1 = require("./svg-components/Conversion");

var Whatsapp_1 = require("./svg-components/Whatsapp");

var DropdownUpSingle_1 = require("./svg-components/DropdownUpSingle");

var Components_1 = require("./svg-components/Components");

var Bot_1 = require("./svg-components/Bot");

var Team_1 = require("./svg-components/Team");

var Filter_1 = require("./svg-components/Filter");

var Tablet_1 = require("./svg-components/Tablet");

var Forward_1 = require("./svg-components/Forward");

var Variable_1 = require("./svg-components/Variable");

var Folder_1 = require("./svg-components/Folder");

var Below_1 = require("./svg-components/Below");

var ArrowRight_1 = require("./svg-components/ArrowRight");

var Clock_1 = require("./svg-components/Clock");

var Board_1 = require("./svg-components/Board");

var Settings_1 = require("./svg-components/Settings");

var Add_1 = require("./svg-components/Add");

var PaintBucket_1 = require("./svg-components/PaintBucket");

var Close_1 = require("./svg-components/Close");

var Flow_1 = require("./svg-components/Flow");

var Profile_1 = require("./svg-components/Profile");

var ArrowUp_1 = require("./svg-components/ArrowUp");

var Intent_1 = require("./svg-components/Intent");

var Image_1 = require("./svg-components/Image");

var Search_1 = require("./svg-components/Search");

var Debug_1 = require("./svg-components/Debug");

var Publish_1 = require("./svg-components/Publish");

var CheckboxUnchecked_1 = require("./svg-components/CheckboxUnchecked");

var Email_1 = require("./svg-components/Email");

var NoChat_1 = require("./svg-components/NoChat");

var Restart_1 = require("./svg-components/Restart");

var Export_1 = require("./svg-components/Export");

var Chat_1 = require("./svg-components/Chat");

var RadioSelected_1 = require("./svg-components/RadioSelected");

var Copy_1 = require("./svg-components/Copy");

var Password_1 = require("./svg-components/Password");

var ToolFix_1 = require("./svg-components/ToolFix");

var NamaIcon_1 = require("./svg-components/NamaIcon");

var Home_1 = require("./svg-components/Home");

var Location_1 = require("./svg-components/Location");

var Back_1 = require("./svg-components/Back");

var Attachment_1 = require("./svg-components/Attachment");

var Change_1 = require("./svg-components/Change");

var DownArrow_1 = require("./svg-components/DownArrow");

var Web_1 = require("./svg-components/Web");

var Disconect_1 = require("./svg-components/Disconect");

var DropdownDownSingle_1 = require("./svg-components/DropdownDownSingle");

var Launch_1 = require("./svg-components/Launch");

var Info_1 = require("./svg-components/Info");

var Desktop_1 = require("./svg-components/Desktop");

var Calendar_1 = require("./svg-components/Calendar");

var Phone_1 = require("./svg-components/Phone");

var Entity_1 = require("./svg-components/Entity");

var Transfer_1 = require("./svg-components/Transfer");

var Above_1 = require("./svg-components/Above");

var Messenger_1 = require("./svg-components/Messenger");

var Options_1 = require("./svg-components/Options");

var QuickReply_1 = require("./svg-components/QuickReply");

var Success_1 = require("./svg-components/Success");

var Visible_1 = require("./svg-components/Visible");

var Edit_1 = require("./svg-components/Edit");

var Refresh_1 = require("./svg-components/Refresh");

var Suggestions_1 = require("./svg-components/Suggestions");

var RadioUnselected_1 = require("./svg-components/RadioUnselected");

var Buttons_1 = require("./svg-components/Buttons");

var Analytics_1 = require("./svg-components/Analytics");

var Minimize_1 = require("./svg-components/Minimize");

var Emoji_1 = require("./svg-components/Emoji");

var Plus_1 = require("./svg-components/Plus");

var Topic_1 = require("./svg-components/Topic");

var Error_1 = require("./svg-components/Error");

var Ok_1 = require("./svg-components/Ok");

var Channels_1 = require("./svg-components/Channels");

var Loading_1 = require("./svg-components/Loading");

var Category_1 = require("./svg-components/Category");

var ArrowDown_1 = require("./svg-components/ArrowDown");

exports.IconList = {
  "Notification": react_1["default"].createElement(Notification_1.SVG, null),
  "Desk": react_1["default"].createElement(Desk_1.SVG, null),
  "Delete": react_1["default"].createElement(Delete_1.SVG, null),
  "List": react_1["default"].createElement(List_1.SVG, null),
  "Telegram": react_1["default"].createElement(Telegram_1.SVG, null),
  "Teams": react_1["default"].createElement(Teams_1.SVG, null),
  "Smarphone": react_1["default"].createElement(Smarphone_1.SVG, null),
  "Trash": react_1["default"].createElement(Trash_1.SVG, null),
  "Dropdown": react_1["default"].createElement(Dropdown_1.SVG, null),
  "CheckboxChecked": react_1["default"].createElement(CheckboxChecked_1.SVG, null),
  "ArrowLeft": react_1["default"].createElement(ArrowLeft_1.SVG, null),
  "Send": react_1["default"].createElement(Send_1.SVG, null),
  "Payment": react_1["default"].createElement(Payment_1.SVG, null),
  "Divider": react_1["default"].createElement(Divider_1.SVG, null),
  "Backward": react_1["default"].createElement(Backward_1.SVG, null),
  "SeeTranscript": react_1["default"].createElement(SeeTranscript_1.SVG, null),
  "Cards": react_1["default"].createElement(Cards_1.SVG, null),
  "Conversion": react_1["default"].createElement(Conversion_1.SVG, null),
  "Whatsapp": react_1["default"].createElement(Whatsapp_1.SVG, null),
  "DropdownUpSingle": react_1["default"].createElement(DropdownUpSingle_1.SVG, null),
  "Components": react_1["default"].createElement(Components_1.SVG, null),
  "Bot": react_1["default"].createElement(Bot_1.SVG, null),
  "Team": react_1["default"].createElement(Team_1.SVG, null),
  "Filter": react_1["default"].createElement(Filter_1.SVG, null),
  "Tablet": react_1["default"].createElement(Tablet_1.SVG, null),
  "Forward": react_1["default"].createElement(Forward_1.SVG, null),
  "Variable": react_1["default"].createElement(Variable_1.SVG, null),
  "Folder": react_1["default"].createElement(Folder_1.SVG, null),
  "Below": react_1["default"].createElement(Below_1.SVG, null),
  "ArrowRight": react_1["default"].createElement(ArrowRight_1.SVG, null),
  "Clock": react_1["default"].createElement(Clock_1.SVG, null),
  "Board": react_1["default"].createElement(Board_1.SVG, null),
  "Settings": react_1["default"].createElement(Settings_1.SVG, null),
  "Add": react_1["default"].createElement(Add_1.SVG, null),
  "PaintBucket": react_1["default"].createElement(PaintBucket_1.SVG, null),
  "Close": react_1["default"].createElement(Close_1.SVG, null),
  "Flow": react_1["default"].createElement(Flow_1.SVG, null),
  "Profile": react_1["default"].createElement(Profile_1.SVG, null),
  "ArrowUp": react_1["default"].createElement(ArrowUp_1.SVG, null),
  "Intent": react_1["default"].createElement(Intent_1.SVG, null),
  "Image": react_1["default"].createElement(Image_1.SVG, null),
  "Search": react_1["default"].createElement(Search_1.SVG, null),
  "Debug": react_1["default"].createElement(Debug_1.SVG, null),
  "Publish": react_1["default"].createElement(Publish_1.SVG, null),
  "CheckboxUnchecked": react_1["default"].createElement(CheckboxUnchecked_1.SVG, null),
  "Email": react_1["default"].createElement(Email_1.SVG, null),
  "NoChat": react_1["default"].createElement(NoChat_1.SVG, null),
  "Restart": react_1["default"].createElement(Restart_1.SVG, null),
  "Export": react_1["default"].createElement(Export_1.SVG, null),
  "Chat": react_1["default"].createElement(Chat_1.SVG, null),
  "RadioSelected": react_1["default"].createElement(RadioSelected_1.SVG, null),
  "Copy": react_1["default"].createElement(Copy_1.SVG, null),
  "Password": react_1["default"].createElement(Password_1.SVG, null),
  "ToolFix": react_1["default"].createElement(ToolFix_1.SVG, null),
  "NamaIcon": react_1["default"].createElement(NamaIcon_1.SVG, null),
  "Home": react_1["default"].createElement(Home_1.SVG, null),
  "Location": react_1["default"].createElement(Location_1.SVG, null),
  "Back": react_1["default"].createElement(Back_1.SVG, null),
  "Attachment": react_1["default"].createElement(Attachment_1.SVG, null),
  "Change": react_1["default"].createElement(Change_1.SVG, null),
  "DownArrow": react_1["default"].createElement(DownArrow_1.SVG, null),
  "Web": react_1["default"].createElement(Web_1.SVG, null),
  "Disconect": react_1["default"].createElement(Disconect_1.SVG, null),
  "DropdownDownSingle": react_1["default"].createElement(DropdownDownSingle_1.SVG, null),
  "Launch": react_1["default"].createElement(Launch_1.SVG, null),
  "Info": react_1["default"].createElement(Info_1.SVG, null),
  "Desktop": react_1["default"].createElement(Desktop_1.SVG, null),
  "Calendar": react_1["default"].createElement(Calendar_1.SVG, null),
  "Phone": react_1["default"].createElement(Phone_1.SVG, null),
  "Entity": react_1["default"].createElement(Entity_1.SVG, null),
  "Transfer": react_1["default"].createElement(Transfer_1.SVG, null),
  "Above": react_1["default"].createElement(Above_1.SVG, null),
  "Messenger": react_1["default"].createElement(Messenger_1.SVG, null),
  "Options": react_1["default"].createElement(Options_1.SVG, null),
  "QuickReply": react_1["default"].createElement(QuickReply_1.SVG, null),
  "Success": react_1["default"].createElement(Success_1.SVG, null),
  "Visible": react_1["default"].createElement(Visible_1.SVG, null),
  "Edit": react_1["default"].createElement(Edit_1.SVG, null),
  "Refresh": react_1["default"].createElement(Refresh_1.SVG, null),
  "Suggestions": react_1["default"].createElement(Suggestions_1.SVG, null),
  "RadioUnselected": react_1["default"].createElement(RadioUnselected_1.SVG, null),
  "Buttons": react_1["default"].createElement(Buttons_1.SVG, null),
  "Analytics": react_1["default"].createElement(Analytics_1.SVG, null),
  "Minimize": react_1["default"].createElement(Minimize_1.SVG, null),
  "Emoji": react_1["default"].createElement(Emoji_1.SVG, null),
  "Plus": react_1["default"].createElement(Plus_1.SVG, null),
  "Topic": react_1["default"].createElement(Topic_1.SVG, null),
  "Error": react_1["default"].createElement(Error_1.SVG, null),
  "Ok": react_1["default"].createElement(Ok_1.SVG, null),
  "Channels": react_1["default"].createElement(Channels_1.SVG, null),
  "Loading": react_1["default"].createElement(Loading_1.SVG, null),
  "Category": react_1["default"].createElement(Category_1.SVG, null),
  "ArrowDown": react_1["default"].createElement(ArrowDown_1.SVG, null)
};